export const canToggle = (option: string, options: string[], maxNumberOfOptions: number) =>
  options.includes(option) || options.length < maxNumberOfOptions;
